import React, { Fragment } from 'react';
import HeaderTop from '../../components/HeaderTop/HeaderTop';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import VideoSection from '../../components/VideoSection/VideoSection';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import CtaSection from '../../components/CtaSection/CtaSection';
import CalculationSection from '../../components/CalculationSection/CalculationSection';
import PartnersSection from '../../components/PartnersSection/PartnersSection';
import TeamSection from '../../components/TeamSection/TeamSection';
import SubscribeSectionS2 from '../../components/SubscribeSectionS2/SubscribeSectionS2';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/snbs_logo1.png'
import Shape from '../../images/d-boy.png'
import About2 from './About2';
import HeaderTopS3 from '../../components/HeaderTopS3/HeaderTopS3';
import NavbarS3 from '../../components/NavbarS3/NavbarS3';
import Img from '../../images/home/ab.jpg'
import Mission from './Mission';

import QualityPolicy from './QualityPolicy';
const AboutPage = () => {
    return (
        <Fragment>
            <HeaderTopS3/>
          <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
            <PageTitle pageTitle={'About Us'} pagesub={'About'} Img={Img}/>
            <About2 hclass={'wpo-about-section section-padding'}/>
            <Mission/>
            <CtaSection />
            <QualityPolicy />
            {/* <ServiceSection hclass={"wpo-service-area section-padding"} ServiceBtn={true} />
            <VideoSection />
            <ProjectSection hclass={'wpo-project-section section-padding'} SectionTitleShow={true} projectBtn={true} />
            <CtaSection />
            <CalculationSection hclass={'wpo-calculation-section'} Boy={Shape} />
            <PartnersSection CollClass={'col col-xs-12'} />
            <TeamSection /> */}
            {/* <SubscribeSectionS2 /> */}
            <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
